var map = {
	"./@sections/about-shop/about-shop.js": 427,
	"./@sections/articles-other/articles-other.js": 1287,
	"./@sections/articles/articles.js": 6741,
	"./@sections/benefits-hover/benefits-hover.js": 3525,
	"./@sections/benefits-swiper/benefits-swiper.js": 3101,
	"./@sections/categories/categories.js": 7383,
	"./@sections/characteristics/characteristics.js": 5373,
	"./@sections/comparison/comparison-diagram/comparison-diagram.js": 8313,
	"./@sections/comparison/comparison-table/comparison-table-block/comparison-table-block.js": 250,
	"./@sections/comparison/comparison.js": 7557,
	"./@sections/faq-section/faq-section.js": 4341,
	"./@sections/features-swiper/features-swiper.js": 4845,
	"./@sections/filter/blocks/filter-colors/filter-colors.js": 343,
	"./@sections/filter/filter.js": 2518,
	"./@sections/glossary/glossary-block/glossary-block.js": 2398,
	"./@sections/header/blocks/dropdown-menu/dropdown-menu.js": 6262,
	"./@sections/header/blocks/dropdown-menu/js/dropdown-menu-core.js": 1292,
	"./@sections/header/blocks/dropdown-menu/js/move-icons.js": 8311,
	"./@sections/header/blocks/dropdown-menu/js/switchable-menu.js": 3993,
	"./@sections/header/blocks/header-search/header-search.js": 8762,
	"./@sections/header/header.js": 893,
	"./@sections/header/js/header-hamburger.js": 3529,
	"./@sections/instructions-all/elems/instructions-all-item/instructions-all-item.js": 6856,
	"./@sections/kit-contents/kit-contents.js": 2885,
	"./@sections/kit-profit/kit-profit.js": 541,
	"./@sections/map-section/map-section.js": 8539,
	"./@sections/map-site/elems/map-site-block/map-site-block.js": 6395,
	"./@sections/new-products/new-products.js": 3389,
	"./@sections/order-verification/order-verification.js": 9479,
	"./@sections/product-page-card/blocks/card-info/card-info.js": 9565,
	"./@sections/promotion-participates/promotion-participates.js": 6709,
	"./@sections/ready-to-help/ready-to-help.js": 3557,
	"./@sections/related-products/related-products.js": 1455,
	"./@sections/resently-viewed/resently-viewed.js": 317,
	"./@sections/reviews-slider/reviews-slider.js": 3501,
	"./@sections/search/search.js": 2755,
	"./@sections/selection/selection-breakpoints.js": 1220,
	"./@sections/selection/selection.js": 5685,
	"./@sections/sidebar-helpful/sidebar-helpful.js": 5482,
	"./@sections/slider-actions/slider-actions.js": 3433,
	"./@sections/slider-main/slider-main.js": 145,
	"./@sections/text-inner/text-inner.js": 6099,
	"./@sections/text-inners-form/elems/__file/__file.js": 8897,
	"./@sections/video-reviews/video-reviews.js": 7285,
	"./@sections/videos-about-product/videos-about-product.js": 1675,
	"./accordions/accordions.js": 806,
	"./ajax/model-viewer/model-viewer.js": 3017,
	"./ajax/popup-modules/give-rating/give-rating.js": 8650,
	"./ajax/popup-modules/popup-input/popup-input.js": 454,
	"./ajax/popup.js": 9850,
	"./ajax/popups.js": 8425,
	"./article-link/article-link.js": 4738,
	"./card-hover-slider/card-hover-slider.js": 8562,
	"./card-info-labels/card-info-labels.js": 4774,
	"./card-labels/card-labels.js": 9502,
	"./catalog-view-switcher/catalog-view-switcher.js": 2282,
	"./cookie/cookie.js": 1448,
	"./countdown/countdown.js": 470,
	"./glossary-tooltip/glossary-tooltip.js": 2344,
	"./info-delivery/info-delivery.js": 4350,
	"./instruction-block/instruction-block.js": 7242,
	"./payment-labels/payment-labels.js": 7832,
	"./popup-accordion/popup-accordion.js": 8226,
	"./price/price.js": 2350,
	"./product-page-labels/product-page-labels.js": 4238,
	"./product-page-slider/elems/product-page-slider-preview/product-page-slider-preview.js": 7471,
	"./product-page-slider/product-page-slider.js": 4558,
	"./product-picker/product-picker.js": 9360,
	"./review/review.js": 56,
	"./sidebar-connection/sidebar-connection.js": 2254,
	"./simple-popup/simple-popup.js": 6682,
	"./slides-counter/slides-counter.js": 6070,
	"./submenu/submenu.js": 4674,
	"./tabs-mobile-select/tabs-mobile-select.js": 3368,
	"./tabs-nav/tabs-nav.js": 1148,
	"./tags/tags.js": 2426,
	"./tooltip/tooltip.js": 486,
	"./up-button/up-button.js": 4564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;